module.exports = __webpack_public_path__ + "static/img/case6.c3bb305.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case6.png
// module id = ivaL
// module chunks = 1